/** @flow */

import {
  GetEmployeeIdentityData,
  GetEmployeeIdentityDataSuccess,
  GetEmployeeIdentityDataError,
  GetEmployeeIdentityDataEffective,
  GetEmployeeIdentityDataEffectiveSuccess,
  GetEmployeeIdentityDataEffectiveError,
  GetEmployeeIdentityChangeSet,
  GetEmployeeIdentityChangeSetSuccess,
  GetEmployeeIdentityChangeSetError,
  UpdatePlatformDataSecurityEmployeeIdentity,
  UpdatePlatformDataSecurityEmployeeIdentitySuccess,
  UpdatePlatformDataSecurityEmployeeIdentityError,
  GetPlatformDataSecurityEmployeeIdentitySchema,
  GetPlatformDataSecurityEmployeeIdentitySchemaSuccess,
  GetPlatformDataSecurityEmployeeIdentitySchemaError,
  SetEmployeeIdentityMainOptionsModalVisibility,
  SetEmployeeIdentitySecurityQuestionsModalVisibility,
  SetEmployeeIdentityAccessAuditModalVisibility,
} from "@modules/service/constants/actions";
import * as employeeIdentityReducers from "./reducers";
import initialState from "./state";
import type { EmployeeIdentityState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: EmployeeIdentityState = initialState,
  action: Object,
): EmployeeIdentityState => {
  const act = {
    [GetEmployeeIdentityData]: employeeIdentityReducers.onGetEmployeeIdentityData,
    [GetEmployeeIdentityDataSuccess]: employeeIdentityReducers.onGetEmployeeIdentityDataSuccess,
    [GetEmployeeIdentityDataError]: employeeIdentityReducers.onGetEmployeeIdentityDataError,
    [GetEmployeeIdentityChangeSet]: employeeIdentityReducers.onGetEmployeeIdentityChangeSet,
    [GetEmployeeIdentityChangeSetSuccess]:
      employeeIdentityReducers.onGetEmployeeIdentityChangeSetSuccess,
    [GetEmployeeIdentityChangeSetError]:
      employeeIdentityReducers.onGetEmployeeIdentityChangeSetError,
    [UpdatePlatformDataSecurityEmployeeIdentity]:
      employeeIdentityReducers.onUpdatePlatformDataSecurityEmployeeIdentity,
    [UpdatePlatformDataSecurityEmployeeIdentitySuccess]:
      employeeIdentityReducers.onUpdatePlatformDataSecurityEmployeeIdentitySuccess,
    [UpdatePlatformDataSecurityEmployeeIdentityError]:
      employeeIdentityReducers.onUpdatePlatformDataSecurityEmployeeIdentityError,
    [GetEmployeeIdentityDataEffective]: employeeIdentityReducers.onGetEmployeeIdentityDataEffective,
    [GetEmployeeIdentityDataEffectiveSuccess]:
      employeeIdentityReducers.onGetEmployeeIdentityDataEffectiveSuccess,
    [GetEmployeeIdentityDataEffectiveError]:
      employeeIdentityReducers.onGetEmployeeIdentityDataEffectiveError,
    [GetPlatformDataSecurityEmployeeIdentitySchema]:
      employeeIdentityReducers.onGetPlatformDataSecurityEmployeeIdentitySchema,
    [GetPlatformDataSecurityEmployeeIdentitySchemaSuccess]:
      employeeIdentityReducers.onGetPlatformDataSecurityEmployeeIdentitySchemaSuccess,
    [GetPlatformDataSecurityEmployeeIdentitySchemaError]:
      employeeIdentityReducers.onGetPlatformDataSecurityEmployeeIdentitySchemaError,
    [SetEmployeeIdentityMainOptionsModalVisibility]:
      employeeIdentityReducers.onSetEmployeeIdentityMainOptionsModalVisibility,
    [SetEmployeeIdentitySecurityQuestionsModalVisibility]:
      employeeIdentityReducers.onSetEmployeeIdentitySecurityQuestionsModalVisibility,
    [SetEmployeeIdentityAccessAuditModalVisibility]:
      employeeIdentityReducers.onSetEmployeeIdentityAccessAuditModalVisibility,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
